module.exports = __webpack_public_path__ + "static/media/poi_hospital_multi.7301b36a.svg";